import { Tooltip } from 'antd';
import { useCallback, useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { PrintIcon } from 'src/icons';
import EncounterPrintPreview from './EncounterPrintPreview';
import { useAuth } from '@frontegg/react';
import { analytics } from 'src/services';

const TriggerPrintEncounter = ({
  record,
  setSelectedRecord,
  selectedRecord,
  editedSummary,
  setCurrentEncounter,
  setRecord,
  setIsStreaming,
  setIsRecording,
  autoChangeStatusToInProgress,
  currentPractitioner,
}) => {
  const onBeforeGetContentResolve = useRef(null);
  const componentRef = useRef(null);
  const isMobileView = window.innerWidth <= 1260;
  const { user } = useAuth();

  const handleOnBeforeGetContent = useCallback(() => {
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;
      setSelectedRecord({ ...record });
    });
  }, [record, setSelectedRecord]);

  useEffect(() => {
    if (
      selectedRecord &&
      (editedSummary?.summary_json || editedSummary?.summary_json === '') &&
      typeof onBeforeGetContentResolve.current === 'function'
    ) {
      onBeforeGetContentResolve.current();
    }
  }, [editedSummary?.summary_json, selectedRecord]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: record?.description,
    onBeforeGetContent: handleOnBeforeGetContent,
    onAfterPrint: () => {
      // Reset the Promise resolve so we can print again
      onBeforeGetContentResolve.current = null;
      setSelectedRecord();
    },
  });

  const handlePrintWithAnalytics = () => {
    // First, select this encounter row
    setRecord(record);
    setIsStreaming(false);
    setIsRecording(false);
    setCurrentEncounter(record);
    autoChangeStatusToInProgress(record);
    localStorage.setItem(
      `${currentPractitioner?.org_uuid}_selectedEncounter`,
      JSON.stringify(record)
    );

    // Then trigger analytics and print
    analytics.track('Clicked Print Note From Aura', {
      mobile: isMobileView,
      description: record?.description,
      created_at: record?.created_at,
      email: user?.email,
    });
    handlePrint();
  };

  return (
    <>
      <Tooltip title="Print note" placement="topRight">
        <span
          className="dropdown-text flex items-center space-x-2"
          onClick={handlePrintWithAnalytics}
        >
          <PrintIcon />
        </span>
      </Tooltip>

      <div className="hidden">
        {record && (
          <div ref={componentRef} className="p-4">
            <EncounterPrintPreview
              editedSummary={editedSummary}
              record={record}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default TriggerPrintEncounter;
